<template>
  <section class="import-topic">
    You can import your tasks into the system as csv file. It should have an appropriate structure, e.g.:
    <pre>
          "question","text","label"
          "Is this hello world?","Hello world",true
      </pre
    >
    <yn-file-upload color="primary" accept=".csv" @change="upload">Upload CSV</yn-file-upload>
  </section>
</template>

<script>
import FileUpload from '@/components/common/FileUpload';
export default {
  components: {
    'yn-file-upload': FileUpload
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },

  methods: {
    async upload([file]) {
      try {
        const result = await this.$store.dispatch('topics/import', { id: this.id, file });

        this.$toast.success({
          title: 'Import completed',
          message: `${result.length} tasks were added`
        });
      } catch (e) {
        this.$toast.error({
          title: 'Import failed',
          message: `Please, try again later or contact our development team.`
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.import-topic {
  pre {
    background-color: rgba(242, 242, 242, 0.75);
    white-space: pre-line;
    padding: 1rem;
  }
}
</style>
